import {
  HttpErrorResponse,
  HttpInterceptor,
  HttpResponse
} from '@angular/common/http';
import { HttpRequest } from '@angular/common/http';
import { HttpHandler } from '@angular/common/http';
import { HttpEvent } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { CoreUtilsService } from './core-utils';
// import { environment } from 'apps/smart-app/src/environments/environment';
import { Environment, ENVIRONMENT } from './core.models';

@Injectable({
  providedIn: 'root'
})
export class CoreHttpInterceptor implements HttpInterceptor {
  private utils = inject(CoreUtilsService);
  private env = inject<Environment>(ENVIRONMENT);

  // Data will be encryoted for following request method
  filterRequests: Array<string> = ['POST', 'PUT'];

  // Encryption will be applied to below provided routes
  encryptApi: Array<string> = [
    'rest/users/reset_password/authorize',
    'rest/users/reset_password',
    'rest/users/me/password',
    'rest/onboarding/authorize',
    'rest/onboarding',
    'rest/login'
  ];

  // Enable/disable encryption using the environment variable "useEncryption"
  private useEncryption: boolean = this.env.useEncryption;

  /**
   * Http Interceptor to handle the http request
   * @param { HttpRequest } req
   * @param { HttpHandler } next
   * @returns HttpEvent
   */
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Check if the current url is external link with http and contains rest
    // return next.handle(req);
    const match = this.encryptApi.find(element => {
      if (req.url.includes(element)) {
        return true;
      }
    });
    if (
      req &&
      req.url &&
      req.url.indexOf('http') >= 0 &&
      req.url.indexOf('rest') >= 0
    ) {
      if (this.filterRequests.indexOf(req.method) >= 0 && match !== undefined) {
        if (!this.useEncryption) {
          const cloneReq = req.clone({
            body: {
              ...req.body,
              use_encryption: this.useEncryption
            }
          });
          return next.handle(cloneReq);
        }
        if (req.body && !(req.body instanceof FormData)) {
          const encryptedData = this.utils.encrypt(JSON.stringify(req.body));
          const ecncryptedRequest = req.clone({
            body: encryptedData
          });
          return next.handle(ecncryptedRequest);
        }
      }
    }
    return next.handle(req);
  }
}
